import React from "react";
import GalleryReusable from "../../components/gallery/GalleryReusable";
import { Grid, useMediaQuery } from "@mui/material";
import SwiperGallery from "../../components/gallery/SwiperGallery";
import "./css/projects.css";
import ProjectHooks from "./hooks/ProjectHooks";
import { gallery_utils } from "../../components/utils/GalleryUtils";
import { useSelector } from "react-redux";
import LightboxComponent from "../../components/lightbox/LightboxComponent";

const Projects = () => {
  const { ...param } = ProjectHooks();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const lightbox_status = useSelector(
    (state) => state.GlobalReducer.lightbox_status
  );
  console.log(lightbox_status);

  return (
    <>
      <Grid
        container
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 3 }}
        rowSpacing={1}
        justifyContent="center"
        p={1}
      >
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <h3 className="projects-header-title">building beyond bounderies</h3>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} className="gallery-images">
          {isMobile ? (
            <SwiperGallery />
          ) : (
            <GalleryReusable
              lightbox_status={lightbox_status}
              handleOpenLightbox={param.handleOpenLightbox}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Projects;
